module.exports = __webpack_public_path__ + "img/1wvVwqVRzwzyuJuBYPIcwV4ufc0HA8UC6.6048905b.png";